<template name="filtering">
  <transition>
    <div
      class="flex md:flex-row flex-col items-start justify-start px-6 py-0 w-full z-50 absolute -mt-2 lg:ml-20"
    >
      <div
        id="popover"
        class="transition duration-150 ease-in-out md:mt-0 mt-0 top-0 left-0 sm:ml-10 md:ml-10 w-11/12 lg:w-6/12 z-50"
      >
        <div class="w-full bg-white border rounded-lg shadow-2xl">
          <div class="relative bg-gray-200 rounded-t py-3 px-4">
            <div class="flex justify-between">
              <button
                class="focus:underline focus:text-gray-600 hover:text-gray-600 focus:outline-none text-gray-800 cursor-pointer md:block"
                @click="$emit('close')"
              >
                <i class="fas fa-times close-icon text-lg" title="Close"></i>
              </button>

              <button
                class="focus:text-gray-600 hover:text-gray-600 focus:outline-none text-gray-800 cursor-pointer md:block pr-2 text-xs"
                @click="resetFilter()"
              >
                <i class="fas fa-redo pr-1 txt-xs" title="Clear"></i> Clear
                filter
              </button>
            </div>

            <i
              class="fas fa-caret-up hidden md:block absolute top-0 -mt-6 mr-56 right-0 bottom-0 text-5xl text-gray-200"
            ></i>
          </div>
          <div class="w-full h-full pl-4 pr-3">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <div class="form-box border-gray-50 border-opacity-25 pb-6">
                  <div class="form-box-title">Calendar Year</div>
                  <p class="filter-item-button-on text-white font-bold py-2 pl-3 rounded">
                    {{ calendar.name }}
                  </p>
                </div>
                <div class="form-box border-gray-50 border-opacity-25">
                  <div class="form-box-title">Class / Group</div>
                  <p class="bg-white">
                    <ClassDropdown
                      :classSelected="selectedClass"
                      @classValueChanged="classSelect"
                      v-bind:class="
                        selectedClass.id > 0
                          ? 'filter-item-button-on text-gray-900'
                          : 'filter-item-button-off'
                      "
                    ></ClassDropdown>
                  </p>
                </div>

                <div class="form-box border-0" v-if="isCurrentYear">
                  <div class="form-box-title">Year Groups</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in yearDropdown"
                      :key="item.key_value"
                      class="inline-block mr-2"
                    >
                      <button
                        type="button"
                        @click="filterYearValue(item.key_value)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inYearFilter(item.key_value)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inYearFilter(item.key_value)
                              ? 'fa-check-square'
                              : 'fa-square'
                          "
                        ></i>
                        Y{{ item.letter }}
                      </button>
                    </li>
                  </ul>
                </div>


                <div class="form-box border-gray-50 border-opacity-25" v-if="hasCrews">
                  <div class="form-box-title">Pupil Crews</div>
                  <p class="bg-white">
                    <Dropdown
          :options="crewDropdown"
          :selected="selectedCrew"
          v-on:updateOption="crewSelect"
          class="text-left px-0 bg-white mr-0"
        ></Dropdown>

            
                  </p>
                </div>

              </div>

              <div class="border-l border-gray-50 pl-5">
                <div class="form-box border-gray-50 border-opacity-25">
                  <div class="form-box-title w-full">
                    <div class="w-full pb-2"> Search Tags </div>



                    <div class="flex pb-2">
                      <div
                        class="bg-blue-500 tag-example mr-2 w-10"
                        @click="addTags('sen')"
                      >
                        #sen
                      </div>

                      <div
                        class="bg-orange-500 mr-2 tag-example"
                        @click="addTags('ofsted')"
                      >
                        #ofsted
                      </div>

                      <div
                        class="mr-2 tag-example"
                        style="background-color: #ef6c00;"
                        @click="addTags('bronze')"
                      >
                        #bronze
                      </div>

                      <div
                        class="mr-2 tag-example w-12"
                         style="background-color: #616161;"
                        @click="addTags('silver')"
                      >
                        #silver
                      </div>

                      <div
                        class="mr-2 tag-example w-10"
                                  style="background-color: #fdd835;"
                        @click="addTags('gold')"
                      >
                        #gold
                      </div>

                      <div
                        class="bg-red-500 mr-2 tag-example w-10"
                        @click="addTags('20percent')"
                      >
                        #20%
                      </div>
                    
                    </div>
                  </div>
                  <div class="relative">
                    <div
                      class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none"
                    >
                      <svg
                        class="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="search"
                      class="h-full text-gray-700 placeholder-gray-500 w-11/12 bg-gray-100 rounded shadow-sm p-2 pl-10 mr-3 mt-1"
                      name="search"
                      v-model="search"
                      placeholder="Enter tags to search..."
                    />
                  </div>
                  <div class="mt-4 text-center" v-if="isEvidenceReport" >
                    <ul class="mb-1 w-full">
                      <li class="mr-2 inline-block">
                        <button
                          type="button"
                          @click="includePupils = false"
                          class="filter-item-button hover:bg-opacity-50 wide"
                          v-bind:class="
                            !includePupils
                              ? 'filter-item-button-on'
                              : 'filter-item-button-off'
                          "
                        >
                          <i
                            class="far pr-1"
                            v-bind:class="
                              !includePupils ? 'fa-check-circle' : 'fa-circle'
                            "
                          ></i>
                          Evidence Tags
                        </button>
                      </li>

                      <li class="mr-2 inline-block">
                        <button
                          type="button"
                          @click="includePupils = true"
                          class="filter-item-button hover:bg-opacity-50 wide"
                          v-bind:class="
                            includePupils
                              ? 'filter-item-button-on'
                              : 'filter-item-button-off'
                          "
                        >
                          <i
                            class="far pr-1"
                            v-bind:class="
                              includePupils ? 'fa-check-circle' : 'fa-circle'
                            "
                          ></i>
                          Pupil Tags
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>



                <div v-if="isEvidenceReport" class="form-box no-border">
                  <div class="form-box-title">Dates</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in dateFilterList"
                      :key="item.key"
                      class="mr-2 inline-block"
                    >
                      <button
                        type="button"
                        @click="updateDateFilter(item)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inDateFilter(item)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inDateFilter(item) ? 'fa-check-circle' : 'fa-circle'
                          "
                        ></i>
                        {{ item.title }}
                      </button>
                    </li>
                  </ul>

                  <div
                    class="flex flex-wrap mr-1 mt-3"
                    v-if="selectSpecificRange"
                  >
                    <div class="w-full md:w-1/2 pr-1 mb-6 md:mb-0">
                      <label class="form-label" for="grid-title">
                        From date</label
                      >
                      <datetime
                        v-model="startDate"
                        input-class="date-input"
                        :format="{
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }"
                        :auto="true"
                      ></datetime>
                    </div>

                    <div class="w-full md:w-1/2 pl-1">
                      <label class="form-label" for="grid-title">
                        To date</label
                      >
                      <datetime
                        v-model="endDate"
                        input-class="date-input"
                        :format="{
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }"
                        :auto="true"
                      ></datetime>
                    </div>
                  </div>
                </div>

                <div v-if="!isEvidenceReport" class="form-box no-border">
                  <div class="form-box-title">Criteria</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in typeDropdown"
                      :key="item.value"
                      class="inline-block mr-2"
                    >
                      <button
                        type="button"
                        @click="filterTypeValue(item.value)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inTypeFilter(item.value)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inTypeFilter(item.value)
                              ? 'fa-check-square'
                              : 'fa-square'
                          "
                        ></i>
                        {{ item.name }}
                      </button>
                    </li>
                  </ul>
                </div>
            
              </div>
            </div>
          </div>

          <div
            class="w-full text-center bg-gray-200 pt-5 rounded-br-lg rounded-bl-lg"
          >
            <button
              @click="filterButtonPressed()"
              class="mx-auto w-1/3 mb-4 focus:ring-2 focus:ring-offset-2 rounded-md focus:ring-indigo-600 transition duration-150 ease-in-out hover:bg-indigo-600 focus:outline-none bg-indigo-700 rounded-r text-white px-3 py-1 text-sm"
            >
              Apply filter
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";
import { Datetime } from "vue-datetime";
import { CrewService } from "@/services/crew.service";

const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");
import { filterTypeList } from "@/assets/js/utils";
import { calendarYearList } from "@/assets/js/utils";
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";
import { ReportingFilter } from "@/services/reporting.service";
import Dropdown from "@/components/Dropdown.vue";

const DateList = [
  {
    key: "today",
    title: "Last 24 hours",
    since: moment().subtract(1, "days"),
    until: moment().endOf("day"),
  },
  {
    key: "week",
    title: "Last week",
    since: moment().subtract(1, "weeks"),
    until: moment().add(5),
  },
  {
    key: "month",
    title: "Last month",
    since: moment().subtract(1, "months"),
    until: moment().endOf("day"),
  },
  {
    key: "specific",
    title: "Date range",
    since: moment().subtract(1, "months"),
    until: moment().endOf("day"),
  },
];

export default {
  name: "filtering",
  mixins: [yearGroupMixin],
  props: {
    calendar: { type: Object, required: true },
    values: { type: Object, required: false },
    filterPath: { type: String, required: false },
  },
  computed: {
    yearDropdown() {
      return this.years;
    },
    typeDropdown() {
      let typeList = _.orderBy(this.types, ["id"]);
      return typeList;
    },
    crewDropdown() {
      let parsedCrews = this.crews.map(function (item, index) {
        return { id: index + 1, name: item.title, identifier: item.identifier };
      });

      var results = [{ id: 0, name: "All Crews" }].concat(parsedCrews);
      if (this.selectedCrew.id === undefined) {
        this.selectedCrew = results[0];
      }
      return results;
    },
    hasCrews() {
      return this.crews.length > 0
    },
    selectSpecificRange() {
      return this.selectedDate.key === "specific";
    },
    isCurrentYear() {
      return this.calendar.current === true;
    },
    isEvidenceReport() {
      return this.filterPath === 'evidences'
    }
  },
  data() {
    return {
      dateFilterList: DateList,
      includePupils: false,
      selectedDate: {},
      startDate: moment().subtract(6, "weeks").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),

      types: filterTypeList(),
      cslendarList: [],
      filteredYears: [],
      selectedClass: {},
      filteredCourse: {},

      crews: [],
      selectedCrew: {},

      filteredTypes: [],
      search: "",
      showMoreTags: false,
    };
  },
  watch: {},
  created() {
    CrewService.getAll()
      .then((response) => (this.crews = response.data.data))
      .catch((res) => {
        console.log(res);
      });
  },
  mounted() {
    // set preset values if exist
    if (!!Object.keys(this.values).length) {
      if (this.values.years != undefined) {
        this.filteredYears = this.values.years;
      }

      if (this.values.group != undefined) {
        this.classSelect(this.values.group);
      }

      if (this.values.crew != undefined) {
        this.crewSelect(this.values.crew);
      }

      if (this.values.types != undefined) {
        this.filteredTypes = this.values.types;
      }

      if (this.values.date != undefined) {
        this.selectedDate = this.values.date;
      }

      if (this.values.includePupilTags != undefined) {
        this.includePupils = this.values.includePupilTags;
      }

      this.search = this.values.tags;
    }
  },
  methods: {
    updateDateFilter(dt) {
      if (dt.key === this.selectedDate.key) {
        this.selectedDate = {};
      } else {
        this.selectedDate = dt;
      }
    },
    inDateFilter(dt) {
      return this.selectedDate.key === dt.key;
    },
    filterTypeValue(value) {
      if (this.filteredTypes.includes(value)) {
        this.filteredTypes.splice(this.filteredTypes.indexOf(value), 1);
      } else {
        this.filteredTypes.push(value);
      }
    },
    inTypeFilter(value) {
      return this.filteredTypes.includes(value);
    },
    classSelect(value) {
      if (this.selectedClass === undefined) {
        this.selectedClass = {};
      } else {
        this.selectedClass = value;
      }
    },
    crewSelect(value) {
      if (this.selectedCrew === undefined) {
        this.selectedCrew = {};
      } else {
        this.selectedCrew = value;
      }
    },
    courseSelect(value) {
      this.filteredCourse = value;
    },
    filterYearValue(value) {
      if (this.filteredYears.includes(value)) {
        this.filteredYears.splice(this.filteredYears.indexOf(value), 1);
      } else {
        this.filteredYears.push(value);
      }
      this.$emit("yearsUpdated", this.filteredYears);
    },
    inYearFilter(value) {
      return this.filteredYears.includes(value);
    },
    resetFilter() {
      this.filteredYears = [];
      this.filteredCourse = {};
      this.filteredTypes = [];
      this.search = "";
      this.selectedClass = {};
      this.selectedDate = {};
      this.selectedCrew = {}
    },
    addTags(value) {
      let seperator = this.search.length > 0 ? " #" : "#";
      this.search = this.search + seperator + value;
    },
    filterButtonPressed() {
      if (this.selectSpecificRange) {
        this.selectedDate.since = this.startDate;
        this.selectedDate.until = this.endDate;
      }

      let payloadYears =
        this.filteredYears.length > 0 ? this.filteredYears : undefined;
      let payloadClass =
        this.selectedClass.id > 0 ? this.selectedClass : undefined;

      let payloadTypes =
        this.filteredTypes.length > 0 ? this.filteredTypes : undefined;

      let payloadCrew = 
        this.selectedCrew.id > 0 ? this.selectedCrew : undefined


      let payload = new ReportingFilter(
        this.calendar,
        payloadYears,
        payloadClass,
        payloadTypes,
        this.search,
        this.includePupils,
        this.selectedDate,
        payloadCrew
      );
      this.$emit("apply-filter", payload);
    },
  },
  components: {
    ClassDropdown,
    datetime: Datetime,
    Dropdown
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>